/**
 * Calculate the remaining amount for a GRN payment
 * @param invoiceAmount - The total invoice amount
 * @param totalPaidAmount - The total amount already paid
 * @param currentPaymentAmount - The current payment amount being processed (optional, defaults to 0)
 * @returns The remaining amount to be paid (minimum 0)
 */
export const calculateRemainingAmount = (
  invoiceAmount: number,
  totalPaidAmount: number,
  currentPaymentAmount = 0
): number => {
  return Math.max(invoiceAmount - totalPaidAmount + currentPaymentAmount, 0);
};
